/* eslint-disable new-cap */
import React from 'react';
import clipboard from 'clipboard-js';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classes from '../ContactDetails.module.scss';

import ContactDetails from './ContactDetails';

export class ContactDetailsBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      linkIsCopied: false
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.contact.id !== nextProps.contact.id) {
      this.setState({ linkIsCopied: false });
    }
  }

  copyMeetingLink = () => {
    clipboard.copy({
      'text/plain': this.props.contact.inviteURL
    });

    this.setState({
      linkIsCopied: true
    });
  };

  render() {
    const {
      additionalNumbersURL,
      callDisplayName,
      contact,
      hasMeetingLink,
      hideOwner,
      isInCall,
      presentationRestrictionEnabled,
      pstnNumbers
    } = this.props;

    const isCustomContact = contact?.isGroupContact || contact?.isPersonalContact;
    const callingDetails = contact?.dialString || contact?.extension || contact?.sipUri || '';

    return (
      <dl className={classes.contactDetails} data-testid="contact-details-block">
        {!isInCall && !isCustomContact && hasMeetingLink ? (
          <>
            <dt>
              <FormattedMessage id="components.contactDetails.meetingLink" defaultMessage="Meeting link" />
            </dt>
            <dd title={contact.inviteURL}>{contact.inviteURL}</dd>
            <dd>
              <a
                className={`${classes.copyLink} ${this.state.linkIsCopied ? classes.copied : ''}`}
                onClick={this.copyMeetingLink}
                data-testid="copy-meeting-link"
              >
                {this.state.linkIsCopied ? (
                  <FormattedMessage id="components.contactDetails.linkCopied" defaultMessage="Link copied!" />
                ) : (
                  <FormattedMessage id="components.contactDetails.copyLink" defaultMessage="Copy link" />
                )}
              </a>
            </dd>
          </>
        ) : null}
        {isCustomContact ? (
          <div className={classes.group}>
            <div className={classes.data}>
              <div className={classes.text}>{callingDetails}</div>
            </div>
          </div>
        ) : (
          <ContactDetails
            additionalNumbersURL={additionalNumbersURL}
            callDisplayName={callDisplayName}
            contact={contact}
            hideOwner={hideOwner}
            isInCall={isInCall}
            presentationRestrictionEnabled={presentationRestrictionEnabled}
            pstnNumbers={pstnNumbers}
          />
        )}
      </dl>
    );
  }
}

ContactDetailsBlock.propTypes = {
  callDisplayName: PT.array,
  contact: PT.object.isRequired,
  hideOwner: PT.bool,
  pstnNumbers: PT.array,
  presentationRestrictionEnabled: PT.bool.isRequired,
  isInCall: PT.bool
};

export default ContactDetailsBlock;
